/**
 * CSS styles for the EcadRecorderPageModular component.
 * Extracted from the inline <style> tag to keep the component clean.
 */
export const RECORDER_STYLES = `
  /* ── Neon glow border keyframes ── */
  @keyframes neon-pulse {
    0%, 100% { 
      box-shadow: 
        0 0 8px rgba(56, 189, 248, 0.3),
        0 0 20px rgba(56, 189, 248, 0.15),
        inset 0 0 8px rgba(56, 189, 248, 0.05);
    }
    50% { 
      box-shadow: 
        0 0 12px rgba(56, 189, 248, 0.5),
        0 0 35px rgba(56, 189, 248, 0.25),
        0 0 60px rgba(56, 189, 248, 0.1),
        inset 0 0 12px rgba(56, 189, 248, 0.08);
    }
  }
  @keyframes neon-border-flow {
    0%   { border-color: rgba(56, 189, 248, 0.4); }
    33%  { border-color: rgba(139, 92, 246, 0.4); }
    66%  { border-color: rgba(56, 189, 248, 0.5); }
    100% { border-color: rgba(56, 189, 248, 0.4); }
  }

  .recorder-modal {
    background: #0f172a !important;
    color: #f8fafc !important;
    border: 1.5px solid rgba(56, 189, 248, 0.35) !important;
    border-radius: 16px !important;
    box-shadow: 
      0 25px 50px -12px rgba(0, 0, 0, 0.7),
      0 0 15px rgba(56, 189, 248, 0.2),
      0 0 40px rgba(56, 189, 248, 0.08) !important;
    animation: neon-pulse 4s ease-in-out infinite, neon-border-flow 8s ease-in-out infinite !important;
    max-width: 1450px !important;
    width: 95vw !important;
    height: 90vh !important;
    display: flex !important;
    flex-direction: row !important;
    overflow: hidden !important;
  }
  .recorder-modal .modal-header {
    display: none !important;
  }
  .recorder-modal .modal-body {
    padding: 0 !important;
    background: #0f172a !important;
    flex: 1 !important;
    display: flex !important;
    flex-direction: row !important;
    overflow: hidden !important;
  }
  .recorder-modal .modal-footer {
    display: none !important;
  }

  /* ── Sidebar Vertical Navigation ── */
  .studio-sidebar {
    width: 200px;
    min-width: 200px;
    background: rgba(15, 23, 42, 0.95);
    border-right: 1px solid rgba(56, 189, 248, 0.12);
    display: flex;
    flex-direction: column;
    padding: 16px 0;
    gap: 0;
    flex-shrink: 0;
    overflow-y: auto;
  }
  .studio-sidebar-title {
    font-size: .6rem;
    font-weight: 800;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    padding: 0 16px 12px;
    border-bottom: 1px solid #1e293b;
    margin-bottom: 8px;
  }

  .studio-tab {
    background: transparent;
    border: none;
    color: #64748b;
    font-size: 0.72rem;
    font-weight: 600;
    padding: 10px 16px;
    cursor: pointer;
    position: relative;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    text-align: left;
    width: 100%;
    border-left: 3px solid transparent;
  }
  .studio-tab:hover {
    color: #e2e8f0;
    background: rgba(30, 41, 59, 0.6);
    border-left-color: rgba(56, 189, 248, 0.3);
  }
  .studio-tab.active {
    color: #38bdf8;
    background: rgba(56, 189, 248, 0.06);
    border-left-color: #38bdf8;
  }
  .studio-tab.active::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 60%;
    background: #38bdf8;
    box-shadow: 0 0 8px #38bdf8, 0 0 16px rgba(56, 189, 248, 0.4);
    border-radius: 0 3px 3px 0;
  }
  .studio-tab-number {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: rgba(51, 65, 85, 0.6);
    color: #64748b;
    font-size: .58rem;
    font-weight: 800;
    flex-shrink: 0;
    transition: all 0.25s;
  }
  .studio-tab.active .studio-tab-number {
    background: rgba(56, 189, 248, 0.15);
    color: #38bdf8;
    box-shadow: 0 0 6px rgba(56, 189, 248, 0.3);
  }

  .studio-sidebar-spacer {
    flex: 1;
    min-height: 20px;
  }

  .studio-sidebar-footer {
    padding: 12px 12px 0;
    border-top: 1px solid #1e293b;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  /* ── Content area ── */
  .studio-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-width: 0;
    padding: 20px;
  }
  .studio-pane {
    flex: 1;
    display: flex;
    overflow: hidden;
    min-height: 0;
  }

  /* ── Grid for the tab contents ── */
  .recorder-modal-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    flex: 1;
    overflow: hidden;
    height: 100%;
  }
  .recorder-modal-grid > div {
    min-height: 0;
    height: 100%;
  }
  @media (min-width: 992px) {
    .recorder-modal-grid {
      grid-template-columns: 1.4fr 1fr;
    }
  }

  /* ── Button styles ── */
  .recorder-btn-cancel:hover {
    background: #1e293b !important;
    color: #f8fafc !important;
    border-color: #475569 !important;
  }
  .recorder-btn-secondary:hover {
    background: #334155 !important;
    border-color: #475569 !important;
  }
  .recorder-btn-primary:hover:not(:disabled) {
    background: #7dd3fc !important;
    transform: translateY(-1px);
  }
  .recorder-btn-sidebar {
    width: 100%;
    padding: 8px 10px;
    border-radius: 8px;
    font-size: .7rem;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.2s;
  }

  /* ── Animations ── */
  @keyframes ripple-out {
    to {
      transform: translate(-50%, -50%) scale(1.5);
      opacity: 0;
    }
  }
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  @keyframes scaleUp {
    0% { transform: scale(0.6); opacity: 0; }
    100% { transform: scale(1); opacity: 1; }
  }
  @keyframes flow {
    to {
      stroke-dashoffset: -14;
    }
  }
  @keyframes flow {
    to {
      stroke-dashoffset: -14;
    }
  }
  body.ac-recording-active,
  body.ac-recording-active * {
    cursor: none !important;
  }

  /* ── Onboarding Modal Overrides ── */
  .onboarding-modal-custom .modal-body {
    padding: 0 !important;
    background: #ffffff !important;
  }
  
  .onboarding-modal-custom .modal-footer {
    display: none !important;
  }

  /* Custom Onboarding Content styling */
  .onboarding-container {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    color: #1e293b;
  }

  .onboarding-banner {
    background: linear-gradient(135deg, #7f1d1d 0%, #b91c1c 50%, #991b1b 100%);
    padding: 28px 24px;
    position: relative;
    overflow: hidden;
    border-bottom: 3px solid #7f1d1d;
    text-align: center;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
  }

  .onboarding-banner::after {
    content: '';
    position: absolute;
    top: -50px;
    right: -50px;
    width: 180px;
    height: 180px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    filter: blur(25px);
    pointer-events: none;
  }

  .onboarding-banner-title {
    color: #ffffff !important;
    font-size: 1.6rem !important;
    font-weight: 900 !important;
    margin: 0 0 8px 0 !important;
    letter-spacing: 0.5px !important;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
  }

  .onboarding-banner-subtitle {
    color: rgba(255, 255, 255, 0.85) !important;
    font-size: 0.85rem !important;
    font-weight: 700 !important;
    margin: 0 !important;
    text-transform: uppercase !important;
    letter-spacing: 1.5px !important;
  }

  .onboarding-body {
    padding: 32px !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 24px !important;
    min-height: 380px !important;
  }

  .onboarding-step-title {
    font-size: 1.25rem !important;
    font-weight: 800 !important;
    color: #0f172a !important;
    margin: 0 0 4px 0 !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    border-bottom: 2px solid #f1f5f9 !important;
    padding-bottom: 8px !important;
  }

  .onboarding-paragraph {
    font-size: 0.95rem !important;
    color: #334155 !important;
    margin: 0 !important;
    line-height: 1.6 !important;
  }

  /* Grid details */
  .onboarding-grid {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 16px !important;
    margin-top: 8px !important;
  }

  @media (max-width: 600px) {
    .onboarding-grid {
      grid-template-columns: 1fr !important;
    }
  }

  .onboarding-card {
    padding: 16px !important;
    background: #f8fafc !important;
    border-radius: 12px !important;
    border: 1px solid #e2e8f0 !important;
    transition: all 0.25s ease !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 6px !important;
  }

  .onboarding-card:hover {
    border-color: #cbd5e1 !important;
    transform: translateY(-2px) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
  }

  .onboarding-card-title {
    font-size: 0.95rem !important;
    font-weight: 700 !important;
    color: #0f172a !important;
    display: flex !important;
    align-items: center !important;
    gap: 6px !important;
  }

  .onboarding-card-desc {
    font-size: 0.8rem !important;
    color: #475569 !important;
    line-height: 1.45 !important;
  }

  /* Feature row layout */
  .onboarding-row {
    display: flex !important;
    gap: 16px !important;
    align-items: flex-start !important;
    padding: 12px !important;
    background: #f8fafc !important;
    border-radius: 10px !important;
    border: 1px solid #e2e8f0 !important;
  }

  .onboarding-badge {
    background: #e2e8f0 !important;
    padding: 6px 10px !important;
    border-radius: 8px !important;
    font-size: 0.75rem !important;
    font-weight: 800 !important;
    color: #0f172a !important;
    min-width: 65px !important;
    text-align: center !important;
    border: 1px solid #cbd5e1 !important;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05) !important;
  }

  .onboarding-row-text {
    font-size: 0.85rem !important;
    color: #334155 !important;
    line-height: 1.5 !important;
  }

  .onboarding-row-text strong {
    color: #0f172a !important;
    font-size: 0.9rem !important;
  }

  /* Table styling */
  .onboarding-table {
    width: 100% !important;
    border-collapse: collapse !important;
    font-size: 0.85rem !important;
    color: #334155 !important;
    margin-top: 8px !important;
  }

  .onboarding-table th {
    text-align: left !important;
    padding: 10px 12px !important;
    background: #f1f5f9 !important;
    font-weight: 800 !important;
    color: #0f172a !important;
    border-bottom: 2px solid #e2e8f0 !important;
  }

  .onboarding-table td {
    padding: 10px 12px !important;
    border-bottom: 1px solid #e2e8f0 !important;
  }

  .onboarding-table tr:hover td {
    background: #f8fafc !important;
  }

  .onboarding-table kbd {
    background: #f1f5f9 !important;
    border: 1px solid #cbd5e1 !important;
    border-bottom-width: 3px !important;
    padding: 2px 6px !important;
    border-radius: 5px !important;
    font-family: monospace !important;
    font-size: 0.8rem !important;
    font-weight: bold !important;
    color: #0f172a !important;
  }

  /* Animation and simulations */
  .onboarding-sim-box {
    position: relative !important;
    height: 140px !important;
    background: #0f172a !important;
    border-radius: 12px !important;
    border: 1px solid #334155 !important;
    overflow: hidden !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: #f8fafc !important;
    box-shadow: inset 0 4px 12px rgba(0,0,0,0.5) !important;
  }

  /* Spotlight Simulation */
  .spotlight-sim-bg {
    position: absolute !important;
    inset: 0 !important;
    background: rgba(0, 0, 0, 0.85) !important;
    z-index: 1 !important;
  }

  .spotlight-sim-glow {
    position: absolute !important;
    width: 90px !important;
    height: 90px !important;
    border-radius: 50% !important;
    background: transparent !important;
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.8), 0 0 15px rgba(255,255,255,1) !important;
    z-index: 2 !important;
    animation: spotlightMove 6s ease-in-out infinite !important;
  }

  @keyframes spotlightMove {
    0%, 100% { left: 20%; top: 20%; }
    25% { left: 70%; top: 30%; }
    50% { left: 40%; top: 60%; }
    75% { left: 60%; top: 20%; }
  }

  .spotlight-sim-text {
    z-index: 0 !important;
    font-size: 0.85rem !important;
    font-family: monospace !important;
    color: #38bdf8 !important;
    white-space: pre-wrap !important;
    padding: 12px !important;
    opacity: 0.7 !important;
  }

  /* Zoom simulation */
  .zoom-sim-lens {
    position: absolute !important;
    width: 80px !important;
    height: 80px !important;
    border-radius: 50% !important;
    border: 2px solid #38bdf8 !important;
    background-color: rgba(15, 23, 42, 0.9) !important;
    box-shadow: 0 0 12px rgba(56, 189, 248, 0.4) !important;
    z-index: 2 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-weight: bold !important;
    color: #38bdf8 !important;
    font-size: 1.3rem !important;
    transform: scale(1) !important;
    animation: zoomAction 4s ease-in-out infinite !important;
  }

  @keyframes zoomAction {
    0%, 100% { transform: scale(1); opacity: 0.5; left: 30%; }
    50% { transform: scale(1.4); opacity: 1; left: 55%; }
  }

  /* Pulsing waves for Voice audio */
  .voice-sim-wave-container {
    display: flex !important;
    align-items: center !important;
    gap: 4px !important;
    height: 40px !important;
  }

  .voice-sim-bar {
    width: 4px !important;
    height: 8px !important;
    background: #ef4444 !important;
    border-radius: 2px !important;
    animation: soundBarGrow 1.2s ease-in-out infinite !important;
  }

  .voice-sim-bar:nth-child(2) { animation-delay: 0.15s !important; height: 16px !important; background: #f87171 !important; }
  .voice-sim-bar:nth-child(3) { animation-delay: 0.3s !important; height: 28px !important; background: #fca5a5 !important; }
  .voice-sim-bar:nth-child(4) { animation-delay: 0.45s !important; height: 14px !important; background: #f87171 !important; }
  .voice-sim-bar:nth-child(5) { animation-delay: 0.6s !important; height: 6px !important; background: #ef4444 !important; }

  @keyframes soundBarGrow {
    0%, 100% { transform: scaleY(1); }
    50% { transform: scaleY(2.2); }
  }

  /* Keypress visual flashing simulator */
  .key-sim-key {
    background: #1e293b !important;
    border: 1px solid #334155 !important;
    border-radius: 6px !important;
    padding: 10px 16px !important;
    font-family: monospace !important;
    font-weight: bold !important;
    color: #38bdf8 !important;
    font-size: 1.1rem !important;
    box-shadow: 0 4px 6px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.1) !important;
    animation: keySimFlash 2.5s ease-in-out infinite !important;
  }

  @keyframes keySimFlash {
    0%, 100% { background: #1e293b; box-shadow: 0 4px 6px rgba(0,0,0,0.2); color: #64748b; border-color: #334155; }
    50% { background: rgba(56, 189, 248, 0.1); box-shadow: 0 0 12px rgba(56, 189, 248, 0.4); color: #38bdf8; border-color: #38bdf8; }
  }

  /* Onboarding footer */
  .onboarding-footer {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    border-top: 1px solid #e2e8f0 !important;
    padding: 20px 32px 24px !important;
    background: #f8fafc !important;
    border-radius: 0 0 12px 12px !important;
  }

  .onboarding-checkbox-label {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    font-size: 0.85rem !important;
    color: #475569 !important;
    cursor: pointer !important;
    font-weight: 500 !important;
    user-select: none !important;
  }

  .onboarding-checkbox {
    width: 16px !important;
    height: 16px !important;
    border-radius: 4px !important;
    border: 1px solid #cbd5e1 !important;
    cursor: pointer !important;
  }

  .onboarding-btn-prev {
    padding: 8px 18px !important;
    border-radius: 8px !important;
    font-size: 0.85rem !important;
    font-weight: 700 !important;
    color: #475569 !important;
    background: #ffffff !important;
    border: 1px solid #cbd5e1 !important;
    cursor: pointer !important;
    transition: all 0.15s ease !important;
  }

  .onboarding-btn-prev:hover {
    background: #f1f5f9 !important;
    color: #1e293b !important;
    border-color: #94a3b8 !important;
  }

  .onboarding-btn-next {
    padding: 8px 18px !important;
    border-radius: 8px !important;
    font-size: 0.85rem !important;
    font-weight: 700 !important;
    color: #ffffff !important;
    background: #0f172a !important;
    border: 1px solid #0f172a !important;
    cursor: pointer !important;
    transition: all 0.15s ease !important;
    box-shadow: 0 2px 4px rgba(15, 23, 42, 0.15) !important;
  }

  .onboarding-btn-next:hover {
    background: #1e293b !important;
    border-color: #1e293b !important;
  }

  .onboarding-btn-start {
    padding: 8px 18px !important;
    border-radius: 8px !important;
    font-size: 0.85rem !important;
    font-weight: 700 !important;
    color: #ffffff !important;
    background: linear-gradient(135deg, #16a34a 0%, #15803d 100%) !important;
    border: none !important;
    cursor: pointer !important;
    transition: all 0.15s ease !important;
    box-shadow: 0 2px 4px rgba(22, 163, 74, 0.2) !important;
  }

  .onboarding-btn-start:hover {
    opacity: 0.9 !important;
    transform: translateY(-1px) !important;
  }

  /* ── Responsive Mobile Media Queries ── */
  @media (max-width: 768px) {
    /* General Modal responsive tweaks */
    .modal-content {
      width: 95% !important;
      max-width: 95vw !important;
      max-height: 92vh !important;
      margin: 12px auto !important;
    }
    
    .modal-footer {
      padding: 12px 16px !important;
    }
    
    .feedback-modal-footer-btns {
      flex-direction: column-reverse !important;
      gap: 8px !important;
      width: 100% !important;
    }
    
    .feedback-modal-footer-btns button {
      width: 100% !important;
      margin: 0 !important;
      text-align: center !important;
      justify-content: center !important;
    }
    
    .feedback-ia-analyze-btn {
      align-self: stretch !important;
      justify-content: center !important;
    }
    
    /* Onboarding Dialog Responsive Tweaks */
    .onboarding-banner {
      padding: 18px 16px !important;
    }
    
    .onboarding-banner-title {
      font-size: 1.25rem !important;
    }
    
    .onboarding-banner-subtitle {
      font-size: 0.72rem !important;
      letter-spacing: 1px !important;
    }
    
    .onboarding-body {
      padding: 16px !important;
      gap: 16px !important;
      min-height: auto !important;
    }
    
    .onboarding-step-title {
      font-size: 1.05rem !important;
      padding-bottom: 6px !important;
    }
    
    .onboarding-paragraph {
      font-size: 0.85rem !important;
    }
    
    .onboarding-card {
      padding: 12px !important;
    }
    
    .onboarding-card-title {
      font-size: 0.85rem !important;
    }
    
    .onboarding-card-desc {
      font-size: 0.75rem !important;
    }
    
    .onboarding-row {
      padding: 8px !important;
      gap: 10px !important;
    }
    
    .onboarding-badge {
      font-size: 0.7rem !important;
      padding: 4px 6px !important;
      min-width: 50px !important;
    }
    
    .onboarding-row-text {
      font-size: 0.78rem !important;
    }
    
    .onboarding-table {
      font-size: 0.78rem !important;
      display: block !important;
      overflow-x: auto !important;
      white-space: nowrap !important;
    }
    
    .onboarding-footer {
      padding: 14px 16px !important;
      flex-direction: column !important;
      align-items: stretch !important;
      gap: 12px !important;
    }
    
    .onboarding-footer .onboarding-checkbox-label {
      justify-content: center !important;
    }
    
    .onboarding-footer > div {
      display: flex !important;
      gap: 8px !important;
      width: 100% !important;
    }
    
    .onboarding-footer button {
      flex: 1 !important;
      text-align: center !important;
      padding: 8px 12px !important;
      font-size: 0.8rem !important;
    }
  }
`;
